"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productHelper = void 0;
const enums_1 = require("./enums");
const moment = require("moment");
const motorCoverTiers_1 = require("../motorCoverTiers");
const Constants_1 = require("../Constants");
exports.productHelper = {
    isMotor(interaction) {
        return interaction.product === enums_1.ProductsEnum.MOTOR;
    },
    isWolfMotor(interaction) {
        return interaction.product === enums_1.ProductsEnum.WOLF_MOTOR;
    },
    isHome(interaction) {
        return interaction.product === enums_1.ProductsEnum.HOME;
    },
    isHomeOrWolfMotor(interaction) {
        return this.isWolfMotor(interaction) || this.isHome(interaction);
    },
    isRenters(interaction) {
        return interaction.product === enums_1.ProductsEnum.RENTERS;
    },
    isMultiProduct(interaction) {
        return interaction.product === enums_1.ProductsEnum.SUBSCRIPTION;
    },
    isAnnualMonthlyPremiumType(interaction) {
        return interaction.factors.premiumType === enums_1.AnnualPolicyPremiumTypeEnum.MONTHLY;
    },
    getIncludedProducts(policies) {
        const isInteractionMotor = (policy) => this.isMotor(policy.interaction);
        const isInteractionRenters = (policy) => this.isRenters(policy.interaction);
        const isInteractionWolfMotor = (policy) => this.isWolfMotor(policy.interaction);
        const onlyRenters = !policies.some(isInteractionMotor) && !policies.some(isInteractionWolfMotor);
        const onlyMotor = !policies.some(isInteractionRenters) && !policies.some(isInteractionWolfMotor);
        const onlyWolfMotor = !policies.some(isInteractionMotor) && !policies.some(isInteractionRenters);
        const includesWolf = this.includesWolfMotorProduct(policies);
        const includesMotor = this.includesMotorProduct(policies);
        const includesRenters = this.includesRentersProduct(policies);
        if (onlyRenters) {
            return enums_1.IncludedProductsEnum.RENTERS;
        }
        else if (onlyMotor) {
            return enums_1.IncludedProductsEnum.MOTOR;
        }
        else if (onlyWolfMotor) {
            return enums_1.IncludedProductsEnum.WOLF_MOTOR;
        }
        else if (!includesWolf && includesMotor && includesRenters) {
            return enums_1.IncludedProductsEnum.MOTOR + enums_1.IncludedProductsEnum.RENTERS;
        }
        else if (includesWolf && includesMotor && includesRenters) {
            return enums_1.IncludedProductsEnum.MOTOR + enums_1.IncludedProductsEnum.RENTERS + enums_1.IncludedProductsEnum.WOLF_MOTOR;
        }
        else if (includesWolf && includesMotor && !includesRenters) {
            return enums_1.IncludedProductsEnum.WOLF_MOTOR + enums_1.IncludedProductsEnum.MOTOR;
        }
        else if (!includesMotor && includesWolf && includesRenters) {
            return enums_1.IncludedProductsEnum.WOLF_MOTOR + enums_1.IncludedProductsEnum.RENTERS;
        }
        else {
            return enums_1.IncludedProductsEnum.MOTOR + enums_1.IncludedProductsEnum.RENTERS;
        }
    },
    isMultipleProduct(policies) {
        if (policies.length > 1) {
            for (const product of policies.map((policy) => policy.interaction.product)) {
                if (product !== product[0]) {
                    return true;
                }
            }
        }
        return false;
    },
    includesMotorProduct(policies) {
        return policies.map((policy) => policy.interaction.product).includes(enums_1.ProductsEnum.MOTOR);
    },
    includesNonExpiredMotorPolicies(policies) {
        return policies
            .filter((policy) => moment(policy.endDate).isSameOrAfter(moment()))
            .map((policy) => policy.interaction.product)
            .includes(enums_1.ProductsEnum.MOTOR);
    },
    includesRentersProduct(policies) {
        return policies.map((policy) => policy.interaction.product).includes(enums_1.ProductsEnum.RENTERS);
    },
    includesNonExpiredRentersPolicies(policies) {
        return policies
            .filter((policy) => moment(policy.endDate).isSameOrAfter(moment()))
            .map((policy) => policy.interaction.product)
            .includes(enums_1.ProductsEnum.RENTERS);
    },
    includesWolfMotorProduct(policies) {
        return policies.map((policy) => policy.interaction.product).includes(enums_1.ProductsEnum.WOLF_MOTOR);
    },
    includesAnnualHomeProduct(policies) {
        return policies.map((policy) => policy.interaction.product).includes(enums_1.ProductsEnum.HOME);
    },
    includesNonExpiredWolfMotorPolicies(policies) {
        return policies
            .filter((policy) => moment(policy.endDate).isSameOrAfter(moment()))
            .map((policy) => policy.interaction.product)
            .includes(enums_1.ProductsEnum.WOLF_MOTOR);
    },
    includesNonExpiredAnnualHomePolicies(policies) {
        return policies
            .filter((policy) => moment(policy.endDate).isSameOrAfter(moment()))
            .map((policy) => policy.interaction.product)
            .includes(enums_1.ProductsEnum.HOME);
    },
    includesOnlyWolfMotorProduct(policies) {
        return this.includesWolfMotorProduct(policies) && !(this.includesMotorProduct(policies) || this.includesRentersProduct(policies));
    },
    includesOnlyNonExpireWolfMotorProduct(policies) {
        return this.includesNonExpiredWolfMotorPolicies(policies) &&
            !(this.includesNonExpiredMotorPolicies(policies) || this.includesNonExpiredRentersPolicies(policies) || this.includesNonExpiredAnnualHomePolicies(policies));
    },
    includesOnlyMonthlySubscriptionProduct(policies) {
        return policies.every(p => p.interaction.product === enums_1.ProductsEnum.MOTOR || p.interaction.product === enums_1.ProductsEnum.RENTERS);
    },
    includesOnlyNonExpireMonthlySubscriptionProduct(policies) {
        return !this.includesNonExpiredWolfMotorPolicies(policies) && (this.includesNonExpiredMotorPolicies(policies) || this.includesNonExpiredRentersPolicies(policies));
    },
    getNewBusinessUrl(product) {
        return `/journey/show/product/${product.valueOf().replace("PropositionFalcon", "").replace("PropositionWolf", "Annual")}/process/nb`;
    },
    getNewBusinessFromDashboardUrl(product) {
        return `${this.getNewBusinessUrl(product)}/dashboardEntryPage`;
    },
    decodeShortenedProduct(shortenedProduct) {
        let product;
        if (shortenedProduct === "MotorInsurance") {
            product = enums_1.ProductsEnum.MOTOR.valueOf();
        }
        else if (shortenedProduct === "RentersInsurance") {
            product = enums_1.ProductsEnum.RENTERS.valueOf();
        }
        else if (shortenedProduct === "AnnualMotorInsurance") {
            product = enums_1.ProductsEnum.WOLF_MOTOR.valueOf();
        }
        else {
            product = shortenedProduct;
        }
        return product;
    },
    getInteractionPolicyData(interaction) {
        if (this.isMQSQuote(interaction)) {
            return interaction.mqsPolicyData;
        }
        else if (this.isWolfMotor(interaction)) {
            return interaction.polarisPolicyData;
        }
        else if (this.isHome(interaction)) {
            return interaction.radarPolicyData;
        }
        return null;
    },
    getActiveAnnualMotorPolicy(policies, policyNumber) {
        return policies.filter(p => this.includesNonExpiredWolfMotorPolicies([p]) && p.policyNumber === policyNumber)[0];
    },
    getActiveAnnualHomePolicy(policies, policyNumber) {
        return policies.filter(p => this.includesNonExpiredAnnualHomePolicies([p]) && p.policyNumber === policyNumber)[0];
    },
    getActiveOrCancelledAnnualMotorPolicy(policies, policyNumber) {
        return policies.filter(p => (this.includesNonExpiredWolfMotorPolicies([p]) || p.status === Constants_1.POLICY_STATUS_MTC) &&
            p.policyNumber === policyNumber)[0];
    },
    getActiveOrCancelledHomePolicy(policies, policyNumber) {
        return policies.filter(p => (this.includesNonExpiredAnnualHomePolicies([p]) || p.status === Constants_1.POLICY_STATUS_MTC) &&
            p.policyNumber === policyNumber)[0];
    },
    isPolicyInRenewalWindow(policy) {
        return moment.utc() >= moment.utc(policy.endDate, moment.ISO_8601).startOf('day').subtract(31, 'days');
    },
    isActivePolicy(policy) {
        return moment.utc(policy.endDate, moment.ISO_8601).isSameOrAfter(moment(), 'day');
    },
    getOneExpectedElement(elements) {
        if (elements.length !== 1) {
            throw new Error(`There must be exactly one element! But found ${elements.length}!`);
        }
        return elements[0];
    },
    atLeastOneActivePolicy(policies) {
        return policies.some((policy) => {
            return exports.productHelper.isActivePolicy(policy);
        });
    },
    parseProductName(productName) {
        if (productName === enums_1.ProductsEnum.WOLF_MOTOR.toString()) {
            return enums_1.ProductsEnum.WOLF_MOTOR;
        }
        if (productName === enums_1.ProductsEnum.MOTOR.toString()) {
            return enums_1.ProductsEnum.MOTOR;
        }
        if (productName === enums_1.ProductsEnum.SUBSCRIPTION.toString()) {
            return enums_1.ProductsEnum.SUBSCRIPTION;
        }
        if (productName === enums_1.ProductsEnum.RENTERS.toString()) {
            return enums_1.ProductsEnum.RENTERS;
        }
        if (productName === enums_1.ProductsEnum.HOME) {
            return enums_1.ProductsEnum.HOME;
        }
        return undefined;
    },
    isDirectDebit(interaction) {
        var _a, _b, _c;
        return ((_a = interaction.paymentDetails) === null || _a === void 0 ? void 0 : _a.paymentType) === 'directDebit' || ((_c = (_b = interaction.paymentDetails) === null || _b === void 0 ? void 0 : _b.directDebitDetails) === null || _c === void 0 ? void 0 : _c.detailsVerified) === true;
    },
    isHomeOrWolfMotorByProduct(product) {
        return this.isHomeByProduct(product) || this.isWolfMotorByProduct(product);
    },
    isHomeByProduct(product) {
        return product === enums_1.ProductsEnum.HOME;
    },
    isWolfMotorByProduct(product) {
        return product === enums_1.ProductsEnum.WOLF_MOTOR;
    },
    isSilverTierAvailable(interaction) {
        return interaction.tieredCovers.map((coverTier) => coverTier.tier).includes(motorCoverTiers_1.MOTOR_COVER_TIERS.MOTOR_TIER_2);
    },
    findActiveAnnualMotorPolicies(policies) {
        return policies.filter(policy => this.includesNonExpiredWolfMotorPolicies([policy]));
    },
    isMQSQuote(interaction) {
        return interaction.generationCode !== null && interaction.generationCode !== undefined && interaction.generationCode.trim() !== '';
    }
};
//# sourceMappingURL=productHelper.js.map